import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  erro: Error | null;
}

/**
 * [23/10/2026] A rede de seguranca que faltava: nenhum erro de tela derruba o sistema
 * inteiro em branco.
 *
 * O QUE ACONTECIA (card [VENDAS] BUG TELA EM BRANCO)
 *
 * O React nao tem meio-termo: um erro nao tratado durante o desenho de QUALQUER
 * componente desmonta a arvore toda. A tela fica branca - sem menu, sem cabecalho, sem
 * mensagem -, e para o usuario o sistema simplesmente sumiu. Foi o que aconteceu em
 * 13/10 ao salvar um pedido com boleto: a venda tinha sido gravada, mas a pessoa so via
 * o branco, recarregava e lancava o pedido de novo.
 *
 * Esta aplicacao nao tinha NENHUM limite de erro - foi a primeira coisa que procurei e
 * nao existia. Sem ele, qualquer defeito futuro, em qualquer tela, aparece do mesmo
 * jeito indecifravel.
 *
 * O QUE ELE RESOLVE, E O QUE NAO RESOLVE
 *
 * Ele NAO conserta o defeito - conserta o SINTOMA. A pessoa passa a ler o que houve, a
 * saber que o trabalho dela pode ter sido salvo, e a ter o texto do erro para mandar ao
 * suporte. E o suporte deixa de receber "ficou tudo branco", que e um chamado sem
 * comeco.
 *
 * POR QUE CLASSE E NAO HOOK: nao existe equivalente em componente de funcao. Os dois
 * metodos abaixo (`getDerivedStateFromError` e `componentDidCatch`) sao a unica porta
 * que o React abre para isto.
 *
 * ONDE ELE FICA: no topo, em volta das rotas. Perto demais de uma tela so protegeria
 * aquela tela; aqui protege todas.
 */
export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { erro: null };

  static getDerivedStateFromError(erro: Error): State {
    return { erro };
  }

  componentDidCatch(erro: Error, info: React.ErrorInfo) {
    // Fica no console do navegador para quem for investigar com a tela aberta. Nao
    // mandamos para o servidor: seria uma rota nova para receber texto de fora, e o
    // ganho nao paga o risco enquanto ninguem estiver olhando esse log.
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', erro, info?.componentStack);
  }

  render() {
    const { erro } = this.state;

    if (!erro) return <>{this.props.children}</>;

    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          fontFamily: 'Roboto, Arial, sans-serif',
          backgroundColor: '#fafafa',
        }}
      >
        <div
          style={{
            maxWidth: '40rem',
            width: '100%',
            backgroundColor: '#fff',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            padding: '32px',
          }}
        >
          <h1 style={{ fontSize: '20px', margin: '0 0 16px', color: '#c62828' }}>
            A tela encontrou um erro e não pôde continuar
          </h1>

          {/* A frase mais importante da pagina. Sem ela a pessoa recarrega e refaz o
              lancamento - foi assim que nasceram pedidos duplicados. */}
          <p style={{ margin: '0 0 12px', lineHeight: 1.6 }}>
            <strong>O que você já tinha salvo não se perdeu.</strong> Se você acabou de
            gravar alguma coisa, ela provavelmente foi gravada — confira na listagem{' '}
            <strong>antes</strong> de lançar de novo, para não duplicar.
          </p>

          <p style={{ margin: '0 0 24px', lineHeight: 1.6 }}>
            Mande o texto abaixo para o suporte: é com ele que dá para achar a causa.
          </p>

          <pre
            style={{
              backgroundColor: '#f5f5f5',
              border: '1px solid #e0e0e0',
              borderRadius: '4px',
              padding: '12px',
              fontSize: '12px',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              margin: '0 0 24px',
            }}
          >
            {erro?.message || String(erro)}
            {'\n'}
            {window.location.pathname}
          </pre>

          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <button
              type='button'
              onClick={() => {
                window.location.href = '/dashboard';
              }}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: '4px',
                backgroundColor: '#1976d2',
                color: '#fff',
                fontSize: '14px',
                cursor: 'pointer',
              }}
            >
              Voltar ao início
            </button>

            <button
              type='button'
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 20px',
                border: '1px solid #1976d2',
                borderRadius: '4px',
                backgroundColor: '#fff',
                color: '#1976d2',
                fontSize: '14px',
                cursor: 'pointer',
              }}
            >
              Tentar de novo
            </button>
          </div>
        </div>
      </div>
    );
  }
}
